export const GangTaskNameEnum = {
  Unassigned: "Unassigned",

  Ransomware: "Ransomware",
  Phishing: "Phishing",
  IdentityTheft: "Identity Theft",
  DDoSAttacks: "DDoS Attacks",
  PlantVirus: "Plant Virus",
  FraudAndCounterfeiting: "Fraud & Counterfeiting",
  MoneyLaundering: "Money Laundering",
  Cyberterrorism: "Cyberterrorism",
  EthicalHacking: "Ethical Hacking",

  MugPeople: "Mug People",
  DealDrugs: "Deal Drugs",
  StrongarmCivilians: "Strongarm Civilians",
  RunACon: "Run a Con",
  ArmedRobbery: "Armed Robbery",
  TraffickIllegalArms: "Traffick Illegal Arms",
  ThreatenAndBlackmail: "Threaten & Blackmail",
  HumanTrafficking: "Human Trafficking",
  Terrorism: "Terrorism",
  VigilanteJustice: "Vigilante Justice",

  TrainCombat: "Train Combat",
  TrainHacking: "Train Hacking",
  TrainCharisma: "Train Charisma",
  TerritoryWarfare: "Territory Warfare",
} as const;
